import React from 'react';
  
function TheTitle () {
        return <h1>Calculator 9000</h1>;
    }
export default TheTitle;